(function(){
  document.documentElement.classList.add('anim-ready');

  function applyVars(el){
    var d = el.getAttribute('data-anim-duration');
    var y = el.getAttribute('data-anim-delay');
    if (d) el.style.setProperty('--anim-duration', d + 'ms');
    if (y) el.style.setProperty('--anim-delay',    y + 'ms');
  }

  var io = null;
  function getIO(){
    if (io) return io;
    if (!('IntersectionObserver' in window)) return null;
    io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -5% 0px', threshold: 0.01 });
    return io;
  }

  function register(root){
    var scope = root || document;
    var els = scope.querySelectorAll('[data-animate],[data-animate-children],[data-anim-loop]');
    els.forEach(applyVars);
    var observer = getIO();
    if (!observer) {
      els.forEach(function(el){ el.classList.add('is-visible'); });
      return;
    }
    scope.querySelectorAll('[data-animate],[data-animate-children]').forEach(function(el){
      if (!el.classList.contains('is-visible')) observer.observe(el);
    });
  }

  register(document);

  // Safety net
  setTimeout(function(){
    document.querySelectorAll('[data-animate],[data-animate-children]').forEach(function(el){
      el.classList.add('is-visible');
    });
  }, 2500);

  // Shopify theme editor: re-register on section load/select so animations play live.
  document.addEventListener('shopify:section:load', function(e){ register(e.target); });
  document.addEventListener('shopify:section:select', function(e){
    e.target.querySelectorAll('[data-animate],[data-animate-children]').forEach(function(el){
      el.classList.remove('is-visible');
    });
    register(e.target);
  });
})();
